import { Applicant } from '@features/opportunities/modules/applicant/services/applicant';
import {
  OptionsPropertyDefinition,
  StringArrayPropertyDefinition,
  StringPropertyDefinition,
  toIdPrimitiveValueCollection,
  toNativePrimitiveArray
} from '@shared/models/schema-property-definition';

import { Beneficiary } from './beneficiary';
import { ContactType } from '../contactType';
import { ContactReferrerArrangement } from '../referrer-arrangement';

export * from './beneficiary';

export namespace Trust {
  export type TrustType =
    | 'Family trust'
    | 'Discretionary trust'
    | 'Unit trust'
    | 'SMSF trust'
    | 'Property / bare trust';
  export interface SchemaPropertyDefinition {
    businessNumber: StringPropertyDefinition;
    contactType: OptionsPropertyDefinition;
    foundationDate: StringPropertyDefinition;
    jurisdiction: OptionsPropertyDefinition;
    managerName: StringPropertyDefinition;
    name: StringPropertyDefinition;
    referrerArrangement: ContactReferrerArrangement.SchemaPropertyDefinition;
    settlorName: StringPropertyDefinition;
    status: OptionsPropertyDefinition;
    trustType: OptionsPropertyDefinition;
    trustees: StringArrayPropertyDefinition;
  }

  export interface Summary {
    id: string;
    name: string;
    applicantType: Applicant.Type;
    trustType: TrustType;
  }

  export interface SchemaContract {
    name: string;
    trustType: TrustType;
    businessNumber: string | null;
    foundationDate: string | null;
    jurisdiction: string | null;
    settlorName: string;
    managerName: string;
    trustees: string[];
    beneficiaries: Beneficiary.SchemaContract;
    contactType: string;
    status: string;
    referrerArrangement: ContactReferrerArrangement.SchemaContract | null;
    nmbAffiliateId?: string | null;
  }

  export interface Model {
    id: string;
    name: string;
    trustType: TrustType;
    businessNumber: string | null;
    foundationDate: string | null;
    jurisdiction: string | null;
    settlorName: string;
    managerName: string;
    trustees: string[];
    beneficiaries: Beneficiary.Model[];
    contactType: ContactType;
    status: string;
    referrerArrangement: ContactReferrerArrangement.Model | null;
    nmbAffiliateId: string | null;
  }

  export function toModel(id: string, t: SchemaContract): Model {
    return {
      id,
      ...t,
      nmbAffiliateId: t.nmbAffiliateId ?? null,
      contactType: t.contactType as ContactType,
      beneficiaries: toNativePrimitiveArray(t.beneficiaries),
      referrerArrangement: ContactReferrerArrangement.toModel(
        t.referrerArrangement
      )
    };
  }

  export function toSchemaContract(c: Partial<Model>): Partial<SchemaContract> {
    return {
      ...c,
      beneficiaries: c.beneficiaries
        ? toIdPrimitiveValueCollection(c.beneficiaries)
        : undefined,
      referrerArrangement: c.referrerArrangement
        ? ContactReferrerArrangement.toSchemaContract(c.referrerArrangement)
        : c.referrerArrangement,
    };
  }
}
